import Province from './Province'

export default Province
